import React from 'react'
import { Box, Text, Paper, Flex, CopyButton, Tooltip, ThemeIcon, Button } from '@mantine/core'
import { IconCheck, IconCopy, IconWindowMaximize } from '@tabler/icons-react'

const FormSharePackageShipment = ({ dataPackage, onCloseForm }) => {
  const apiUrl = process.env.REACT_APP_SERVER_API_URL

  const openNewTab = (url) => {
    window.open(`${url}`, '_blank')
  }

  const handleApiUrl = (api) => {
    if (api.includes('api2dev')) {
      return 'https://app-dev.asiacommerce.net/tracking'
    } else {
      return 'https://app.asiacommerce.net/tracking'
    }
  }

  if (true) {
    console.log('masuk sini')
  }

  if (dataPackage !== null) {
    return (
      <Box>
        <Box>
          <Paper shadow="sm" withBorder p="lg" mb='lg'>
            <Text fz={14} fw='600' mb={12}>Tracking link for this Shipment</Text>
            <Text fz={12} fw='500' c='gray.6' mb={1}>Tracking URL</Text>
              <Flex gap={4} align='center'>
                <Text fz={12} c='blue.9'>{`${handleApiUrl(apiUrl)}/${dataPackage.tracking_code}`}</Text>
                <CopyButton value={`${handleApiUrl(apiUrl)}/${dataPackage.tracking_code}`} timeout={2000}>
                  {({ copied, copy }) => (
                    <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                      <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                        {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                      </ThemeIcon>
                    </Tooltip>
                  )}
                </CopyButton>
                <Tooltip label='Open Link' withArrow position="top">
                  <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${handleApiUrl(apiUrl)}/${dataPackage.tracking_code}`)}>
                    <IconWindowMaximize size={12} />
                  </ThemeIcon>
                </Tooltip>
              </Flex>
          </Paper>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
          </Flex>
        </Box>
      </Box>
    )
  }
}

export default FormSharePackageShipment